export default function () {
  if (Array.from(document.querySelectorAll('img[data-src]')).length > 0) {
    import(
      /* webpackChunkName: "lazy-load-images-module" */ './lazy-load'
    ).then((module) => {
      const LazyLoadImages = module.default
      LazyLoadImages()
    })
  }
}
